"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _lodash = require("lodash");
var _Subsection = _interopRequireDefault(require("./Subsection"));
var _SidenavConsts = require("../SidenavConsts");
var _SidenavUtils = require("../SidenavUtils");
var _accessibility = require("../../../constants/accessibility");
var _SidenavListItem = _interopRequireDefault(require("./SidenavListItem"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.secondary.dark
    }
  };
});
var ParentTab = function ParentTab(props) {
  var focusedTab = props.focusedTab,
    isChildSelected = props.isChildSelected,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    onClick = props.onClick,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    persistDrawerState = props.persistDrawerState,
    selectedTab = props.selectedTab,
    sidenavIsOpen = props.sidenavIsOpen,
    sidenavWidth = props.sidenavWidth,
    tab = props.tab,
    index = props.tabIndex;
  var automationid = tab.automationid,
    _tab$dataMetrics = tab.dataMetrics,
    dataMetrics = _tab$dataMetrics === void 0 ? 'fuse_sidenav_parent_tab' : _tab$dataMetrics,
    icon = tab.icon,
    subSections = tab.subSections,
    text = tab.text;
  var tabRef = (0, _react.useRef)(null);
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    subTabIndex = _useState4[0],
    setSubTabIndex = _useState4[1];

  /* We need the prev tab in order to set the tab index to null
   if the side nav is clicked by a mouse while using the
   arrow Navigation.
   */

  var prevSelectedTabRoute = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    prevSelectedTabRoute.current = selectedTab.tabRoute;
    if (persistDrawerState && (0, _SidenavUtils.isLocalStorageTabExpanded)({
      tabIndex: index,
      tabText: text
    }) && sidenavIsOpen) {
      setExpanded(true);
    }
  }, [index, persistDrawerState, prevSelectedTabRoute, selectedTab, sidenavIsOpen, text]);
  var toggleExpanded = function toggleExpanded() {
    if (sidenavIsOpen) {
      /**
       * minHoverTimeToOpen causes delay of opening sidenav,
       * toggle expanding should be handled when sidenav is open.
       */
      (0, _SidenavUtils.updateTabsExpandedLocalStorage)({
        action: expanded ? 'delete' : 'add',
        tabIndex: index,
        tabText: text
      });
      setExpanded(!expanded);
    }
  };
  var flattenedChildTabs = subSections.reduce(function (subMenuItems, section) {
    return [].concat((0, _toConsumableArray2["default"])(subMenuItems), (0, _toConsumableArray2["default"])(section.childTabs));
  }, []);
  (0, _react.useEffect)(function () {
    /**
     * set the tab to null if the selected tab changes
     * this is to ensure that the tab index does not get
     * out of order if a user mouse clicks on a different nav item
     * */

    if (prevSelectedTabRoute.current !== selectedTab.tabRoute) {
      setSubTabIndex(null);
    }
  }, [selectedTab, prevSelectedTabRoute]);
  (0, _react.useEffect)(function () {
    if (!sidenavIsOpen) {
      setExpanded(false);
    }
  }, [sidenavIsOpen]);
  var handleOnClick = function handleOnClick(event, submenuRoute, submenuCustomOnClick, isKeyPress) {
    var clickIndex = (0, _lodash.findIndex)(flattenedChildTabs, function (child) {
      return child.route === submenuRoute;
    });
    var isClickEvent = event.type === 'click';
    if (clickIndex === -1) return;
    setSubTabIndex(clickIndex);
    onClick(event, {
      isKeyPress: isKeyPress,
      submenuCustomOnClick: submenuCustomOnClick,
      submenuRoute: submenuRoute
    });
    if (tabRef.current) {
      onFocus(isClickEvent ? null : index, null);
      tabRef.current.focus();
    }
  };
  var handleArrowUpNavigationWorker = function handleArrowUpNavigationWorker(isParentTab, tabIndex) {
    var isFirstItem = tabIndex === 0;
    var nextTabIndex = isFirstItem ? null : tabIndex - 1;
    var newTabRoute = isFirstItem ? _SidenavConsts.PARENT_NAVIGATION_ROUTE : null;
    if (!isParentTab && nextTabIndex !== null) {
      var newTab = flattenedChildTabs[nextTabIndex];
      if (newTab) {
        if (newTab.divider) {
          return handleArrowUpNavigationWorker(false, nextTabIndex);
        }
        newTabRoute = newTab.route;
      } else {
        nextTabIndex = 0;
        newTabRoute = null;
      }
    }
    setSubTabIndex(nextTabIndex);
    return newTabRoute;
  };
  var handleArrowUpNavigation = function handleArrowUpNavigation(event, isParentTab) {
    var newTabRoute = handleArrowUpNavigationWorker(isParentTab, subTabIndex);
    onKeyDown(event, newTabRoute);
  };
  var handleArrowDownFunctionalityWorker = function handleArrowDownFunctionalityWorker(isParentTab, tabIndex) {
    var nextTabIndex = isParentTab ? 0 : tabIndex + 1;
    var isLastItem = nextTabIndex >= flattenedChildTabs.length;
    var newTabRoute = null;
    var newTabIndex = isLastItem ? null : nextTabIndex;
    if (newTabIndex !== null) {
      var newTab = flattenedChildTabs[newTabIndex];
      if (newTab.divider) {
        return handleArrowDownFunctionalityWorker(false, newTabIndex);
      }
      newTabRoute = newTab.route;
    }
    setSubTabIndex(newTabIndex);
    return newTabRoute;
  };
  var handleArrowDownFunctionality = function handleArrowDownFunctionality(event, isParentTab) {
    var newTabRoute = handleArrowDownFunctionalityWorker(isParentTab, subTabIndex);
    onKeyDown(event, newTabRoute);
  };
  var handleArrowLeftNavigation = function handleArrowLeftNavigation(event) {
    setExpanded(false);
    onKeyDown(event);
    setSubTabIndex(null);
  };
  var handleEnterNavigation = function handleEnterNavigation(event) {
    event.preventDefault();
    var clickedTab = flattenedChildTabs[subTabIndex];
    if (clickedTab) {
      handleOnClick(event, clickedTab.route, clickedTab.onClick, true);
    } else {
      setExpanded(false);
    }
  };
  var handleSubNavigation = function handleSubNavigation(event) {
    /**
     * The subnavigation requires events to happen at the component level
     * and also calls some events at the parent level
     * to handle different accessibility functionality
     */
    event.stopPropagation();
    switch (event.key) {
      case _accessibility.KEY_DOWN_MAP.ARROW_LEFT:
        {
          handleArrowLeftNavigation(event);
          break;
        }
      case _accessibility.KEY_DOWN_MAP.ARROW_UP:
        {
          handleArrowUpNavigation(event, subTabIndex === null);
          break;
        }
      case _accessibility.KEY_DOWN_MAP.ARROW_DOWN:
        {
          handleArrowDownFunctionality(event, subTabIndex === null);
          break;
        }
      case _accessibility.KEY_DOWN_MAP.ENTER:
        {
          handleEnterNavigation(event);
          break;
        }
      default:
        {
          break;
        }
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (expanded) {
      handleSubNavigation(event);
    } else {
      onKeyDown(event);
    }
  };
  var parentAutoFocus = isFocused && focusedTab.tabRoute === null;
  var handleOnFocus = function handleOnFocus(event) {
    // IMPORTANT do not remove this as it will trigger the menu to reset onfocus
    setSubTabIndex(null);
    event.stopPropagation();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: isSelected ? classes.root : undefined,
    "data-metrics": dataMetrics
  }, /*#__PURE__*/_react["default"].createElement(_SidenavListItem["default"], {
    "aria-controls": "".concat(automationid || dataMetrics, "-subnav"),
    autoFocus: parentAutoFocus,
    automationid: automationid,
    button: true,
    dataMetrics: dataMetrics,
    expanded: expanded,
    hasSubnav: true,
    icon: icon,
    isChildSelected: isChildSelected,
    isFocused: parentAutoFocus,
    isSelected: false,
    onClick: toggleExpanded,
    onFocus: handleOnFocus,
    onKeyDown: handleKeyDown,
    sidenavWidth: sidenavWidth,
    tabIndex: -1,
    tabRef: tabRef,
    text: text
  }), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": expanded,
    timeout: "auto",
    unmountOnExit: true,
    id: "".concat(automationid || dataMetrics, "-subnav")
  }, subSections.map(function (subSection, subSectionIdx) {
    var key = subSection.header || subSectionIdx;
    return /*#__PURE__*/_react["default"].createElement(_Subsection["default"], {
      childTabs: subSection.childTabs,
      focusedTab: focusedTab,
      header: subSection.header,
      key: key,
      onClick: handleOnClick,
      onKeyDown: handleKeyDown,
      selectedTab: selectedTab
    });
  })));
};
var _default = ParentTab;
exports["default"] = _default;
ParentTab.propTypes = process.env.NODE_ENV !== "production" ? {
  focusedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  isChildSelected: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func.isRequired,
  onKeyDown: _propTypes["default"].func.isRequired,
  persistDrawerState: _propTypes["default"].bool,
  selectedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number.isRequired,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  sidenavIsOpen: _propTypes["default"].bool.isRequired,
  sidenavWidth: _propTypes["default"].number,
  tab: _propTypes["default"].shape({
    automationid: _propTypes["default"].string,
    dataMetrics: _propTypes["default"].string,
    icon: _propTypes["default"].element.isRequired,
    subSections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      childTabs: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        dataMetrics: _propTypes["default"].string,
        divider: _propTypes["default"].bool
      }), _propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        dataMetrics: _propTypes["default"].string,
        route: _propTypes["default"].string.isRequired,
        text: _propTypes["default"].string.isRequired
      })])),
      header: _propTypes["default"].string
    })),
    text: _propTypes["default"].string.isRequired
  }).isRequired,
  tabIndex: _propTypes["default"].number
} : {};